import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {Provider} from "react-redux";
import {store} from "./app/store";
import { BrowserRouter,Routes,Route,} from "react-router-dom";
import { AlertProvider } from './Components/ui/AlertProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
<React.StrictMode>
    <Provider store={store}>
        <BrowserRouter>
            <AlertProvider>
                <Routes>
                    <Route path="/*" element={ <App/> } />     
                </Routes>
            </AlertProvider>
        </BrowserRouter>
    </Provider>
</React.StrictMode>
);

